<template>
    <div class="col-md-4" style="left: 113%; top: 15%">
        <button class="solid-btn no-print"
           v-show="authenticated"
           @click="showModal = true"
           @click.prevent="showModal=true">
           Edit Fundraiser
        </button>
        <Modal
            v-model="showModal"
            width="780"
            title="Edit Profile">
            <h6 class="title-6">Hero image</h6>
            <Upload
                ref="upload"
                type="drag"
                :on-success="handleUpload"
                :action="routes.upload_hero_image"
                :format="['jpg','jpeg','png']">
                <div style="padding: 20px 0">
                    <Icon type="ios-cloud-upload" size="65" style="color: #bf131f;"></Icon>
                    <p v-show="selectedFile===''">Click or drag files here to upload</p>
                    <p v-show="selectedFile!== ''">{{selectedFile}}</p>
                </div>
            </Upload>
            <br/>
            <h6 class="title-6">Story</h6>
            <textarea class="input-field" type="text" placeholder="Story" v-model="story" @input="disabled=false"> </textarea>
            <br/>
            <br/>
            <div class="loading" v-loading="loading"></div>
            <div slot="footer" >
                <div class="single-row text-right" >
                    <button class="solid-btn outline"
                            @click="showModal=false"
                            style="width: auto; padding-right: 15px; padding-left: 15px">
                        Cancel
                    </button>
                    <button class="solid-btn"
                            @click="save()"
                            :disabled="disabled"
                            :class="{disabled: disabled}"
                            style="width: auto; padding-right: 15px; padding-left: 15px">
                        Save
                    </button>
                </div>
            </div>
        </Modal>

    </div>
</template>

<script>
export default {
  data () {
    return {
      authenticated: true,
      disabled: true,
      fundraiser: {
      },
      story: '',
      showModal: false,
      heroImage: {},
      selectedFile: '',
      loading: false,
      routes: {
        upload_hero_image: ''
      }
    }
  },

  mounted () {
    this.authenticated = this.$root.$refs.kinf.auth
    window.kinfEvents.$on('EditProfile:sendFundraiser', (fundraiser) => {
      this.fundraiser = fundraiser
      this.story = fundraiser.teacher.personal_statement
    })

    window.kinfEvents.$on('EditProfile:sendRoutes', (routes) => {
      if (routes !== undefined) {
        this.routes = routes
        this.routes.upload_hero_image = this.routes.upload_hero_image.replace('FID', this.fundraiser.id)
        this.routes.fundraiser_show_api = this.routes.fundraiser_show_api.replace('FID', this.fundraiser.id)
        this.routes.fundraiser_update_story = this.routes.fundraiser_update_story.replace('FID', this.fundraiser.id)
      }
    })
  },

  methods: {
    handleUpload (res, file) {
      this.disabled = false
      this.selectedFile = file.name
      const fileList = this.$refs.upload.fileList
      this.$refs.upload.fileList.splice(fileList.indexOf(file), 1)
      window.axios.get(this.routes.fundraiser_show_api).then((response) => {
        window.kinfEvents.$emit('PageFundraiser:fundraiserImageUpdated', response.data.data)
      })
    },
    save () {
      this.disabled = true
      if (this.story != this.fundraiser.teacher.personal_statement) {
        this.loading = true
        window.axios.put(this.routes.fundraiser_update_story, { personal_statement: this.story })
          .then(() => window.location.reload())
      } else {
        window.location.reload()
      }
    }
  }

}
</script>

<style>
.ivu-upload-drag:hover {
    border: 1px dashed #d9232e;
}

.disabled, .disabled:hover {
    background: #E0E0E0;
    color: #eceaea;
}

.loading {
    padding: 5%;
}

</style>



// WEBPACK FOOTER //
// resources/js/views/fundraisers/components/show/EditProfile.vue